import { PaymentTerm } from "client/api-v2";

// Keyed by the enum rather than hand-listed, so a term added to PaymentTerm fails the build here
// instead of silently rendering as its member name and going missing from the create dropdown.
const paymentTermLabels: Record<PaymentTerm, string> = {
  [PaymentTerm.DueUponReceipt]: "Due Upon Receipt",
  [PaymentTerm.Net30]: "Net 30",
  [PaymentTerm.Net45]: "Net 45",
  [PaymentTerm.Net60]: "Net 60",
  [PaymentTerm.Net75]: "Net 75",
  [PaymentTerm.Net90]: "Net 90",
};

/** Display labels for the terms, which the API exchanges as enum member names. */
export const paymentTermOptions: { value: PaymentTerm; label: string }[] = Object.values(PaymentTerm).map((value) => ({
  value,
  label: paymentTermLabels[value],
}));

export function paymentTermLabel(paymentTerm: PaymentTerm): string {
  return paymentTermLabels[paymentTerm];
}
